/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

/**
 * Mobx State Tree Store
 */

const SubBusinessCode = types.model('SubBusinessCode', {
  businessUnitId: types.maybeNull(types.integer),
  subBusinessUnitId: types.maybeNull(types.integer),
  subBusinessUnitName: types.maybeNull(types.string)
});
const CmDirectoryCode = types.model('CmDirectoryCode', {
  subBusinessUnitId: types.maybeNull(types.integer),
  directoryId: types.maybeNull(types.integer),
  directoryName: types.maybeNull(types.string)
});

const CmMetadata = types
  .model('CmMetadata', {
    subBusiness: types.optional(types.array(SubBusinessCode), []),
    cmdirectory: types.optional(types.array(CmDirectoryCode), [])
  })

  .actions((self) => ({
    fetchSubBusiness() {
      Framework.getEventManager().publish(constants.CM_DB_SUB_BUSINESS_CODE);
    },
    fetchDirectory() {
      Framework.getEventManager().publish(constants.CM_DB_DIRECTORY);
    },

    setSubBusiness(response) {
      applySnapshot(self.subBusiness, response.data);
      Framework.getEventManager().publish(constants.CM_INGEST_UNITS, {});
    },
    setDirectory(response) {
      applySnapshot(self.cmdirectory, response.data);
      Framework.getEventManager().publish(constants.CM_INGEST_UNITS, {});
    }
  }));

export default CmMetadata;
